/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

module.exports = {
    "success": true,
    "message": "",
    "result": ["鲜花速递", "除湿机", "跑步机", "蛋糕", "平板电脑", "电视挂架", "电脑桌", "连衣裙", "冬季拖鞋"]

};


//////////////////
// WEBPACK FOOTER
// ./app/views/searchheader/mock.js
// module id = 9
// module chunks = 1 2